import ApiHelper from "../../../shared/ApiHelper";
import Settings from "../../../constants/Settings";
import {IFaqsServiceObj} from "../../../shared/apiServices/IApiInterfaces";

const FrequentlyAskedQuestionsApiHelpers = {
    getAllFaqs: async (): Promise<IFaqsServiceObj[]> => {
        return (await ApiHelper.get(`${Settings.HabitatUrl}/faqs`, true)).data;
    }
}

export default FrequentlyAskedQuestionsApiHelpers
